import { format } from 'date-fns';
import React from 'react';
import styled from 'styled-components/native';

const Time = styled.Text`
  font-family: 'WorkSans-SemiBold'; /* Font Weight 600 */
  font-size: 12px;
  line-height: 20px;
  margin-bottom: 75px;
`;

export type DynamicTimeProps = {
  time: Date;
};

export function formatTime(time: Date): string {
  const now = new Date(),
    oneDayMs = 86400000,
    oneWeekMs = 604800000,
    timeDifference = now.getTime() - time.getTime();
  switch (true) {
    case time.getDate() === now.getDate() && timeDifference <= oneDayMs: // today (1:03 PM)
      return format(time, 'h:mm a');
    case timeDifference > oneWeekMs:
      return format(time, 'MMM do'); // over a week (e.g. AUG 4TH)
    default:
      return format(time, 'EEEE'); // within a week (e.g TUE)
  }
}

const DynamicTime: React.FC<DynamicTimeProps> = ({ time }) => {
  return <Time>{formatTime(time)}</Time>;
};

export default DynamicTime;
